import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Nav from "../Components/Nav";
import { db, auth } from "../config";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { QRCodeCanvas } from "qrcode.react";
import axios from "axios";
import Footer from "../Components/Footer";

function Deposit() {
  const [selectedMethod, setSelectedMethod] = useState("");
  const [amount, setAmount] = useState("");
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [walletAddresses, setWalletAddresses] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUserId(user.uid);
        setUserEmail(user.email);
        try {
          const ref = doc(db, "settings", "walletAddresses");
          const snapshot = await getDoc(ref);
          if (snapshot.exists()) {
            setWalletAddresses(snapshot.data());
          } else {
            console.log("No wallet addresses found!");
          }
        } catch (err) {
          console.error("Error fetching wallet addresses:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setUserId(null);
        setUserEmail(null);
        navigate("/auth/login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId || !selectedMethod || !amount || amount <= 0) {
      alert("Please select a payment method and enter a valid amount.");
      return;
    }

    setSubmitting(true);
    const depositData = {
      userId,
      userEmail,
      method: selectedMethod,
      amount: parseFloat(amount),
      timestamp: new Date().toISOString(),
      status: "pending",
    };

    try {
      const depositRef = doc(db, "deposits", `${userId}_${Date.now()}`);
      await setDoc(depositRef, depositData);

      await axios.post("https://renderbackend-4t2p.onrender.com/send-mail", {
        email: userEmail,
        subject: "Your Deposit Request",
        CompanyName: "APEXYEILD",
        htmlToSend: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #eee; padding: 20px; border-radius: 10px; background-color: #f9f9f9;">
            <div style="text-align: center; margin-bottom: 20px;">
              <img src="https://apexyeild.com/public/uploads/logo/light.png" alt="APEXYEILD Logo" style="height: 60px;" />
              <h2 style="margin: 10px 0; color: #1a1a1a;">APEXYEILD</h2>
            </div>
            <h3 style="color: #333;">Hi!</h3>
            <p style="color: #555;">We've received your deposit request:</p>
            <table style="width: 100%; border-collapse: collapse; margin: 15px 0;">
              <tr>
                <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Method:</strong></td>
                <td style="padding: 8px; border-bottom: 1px solid #ddd;">${selectedMethod}</td>
              </tr>
              <tr>
                <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Amount:</strong></td>
                <td style="padding: 8px; border-bottom: 1px solid #ddd;">$${parseFloat(amount).toFixed(2)}</td>
              </tr>
            </table>
            <p style="color: #555;">Please complete your deposit by sending the amount to the wallet address below:</p>
            <p style="color: #111;"><strong>${selectedMethod}:</strong> ${walletAddresses[selectedMethod] || "Not available"}</p>
            <p style="margin-top: 30px; color: #555;">Once we confirm the payment, your account will be credited accordingly.</p>
            <p style="margin-top: 20px; color: #555;">Thank you for choosing APEXYEILD!</p>
            <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;" />
            <p style="font-size: 12px; color: #aaa; text-align: center;">
              © ${new Date().getFullYear()} APEXYEILD. All rights reserved.
            </p>
          </div>
        `,
      });

      setIsModalOpen(true);
    } catch (error) {
      console.error("Deposit submission or email failed:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const copyToClipboard = () => {
    const address = walletAddresses[selectedMethod];
    if (address) {
      navigator.clipboard.writeText(address).then(() => {
        alert("Wallet address copied!");
      }).catch((err) => {
        console.error("Failed to copy: ", err);
        alert("Failed to copy wallet address.");
      });
    } else {
      alert("No wallet address available for the selected method.");
    }
  };

  // if (loading) {
  //   return (
  //     <div className="text-center">
  //       <i className="fas fa-spinner fa-spin fa-2x"></i> Loading...
  //     </div>
  //   );
  // }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>APEXYEILD | Deposit</title>
        <link
          rel="icon"
          href="https://apexyeild.com/auth/storage/app/public/photos/IQAXeGtikmark.png1744508352"
          type="image/png"
        />
      </Helmet>

      <style>
        {`
          .custom-select {
            display: inline-block;
            max-width: 100%;
            height: calc(2.25rem + 2px);
            padding: .375rem 1.75rem .375rem .75rem;
            line-height: 1.5;
            color: #0b57e3;
            vertical-align: middle;
            background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
            background-size: 8px 10px;
            border: 4px solid black;
            border-radius: .25rem;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }
          .custom-select:focus {
            border-color: #80bdff;
            outline: 0;
          }
          .custom-select:disabled {
            color: #868e96;
            background-color: #e9ecef;
          }
          .footer-block {
            min-height: 400px;
            padding: 50px 0;
            background: linear-gradient(to right, #212529, #131516), url(../img/project4.jpg);
          }
          .foot-header {
            font-family: "Montserrat", Sans-serif;
            font-weight: 600;
            font-size: 1rem;
            margin-bottom: 25px;
            color: #4A4A4A;
          }
          .foot {
            display: block;
            font-size: small;
            margin-bottom: 8px;
            font-family: "Montserrat", Sans-serif;
            color: #A1A39E !important;
          }
          .foot:hover {
            text-decoration: none !important;
            color: #FE413C !important;
          }
          .foot::before {
            content: "-";
            margin-right: 3px;
            color: #FE413C;
          }
          .footer-credit {
            font-family: "Montserrat", Sans-serif;
            color: #FE413C;
            font-size: small;
          }
          .footer-block .small-image {
            width: 250px;
            height: auto;
          }
          .qr-code-container {
            margin-top: 20px;
            text-align: center;
          }
          .wallet-address {
            word-break: break-all;
            margin-top: 10px;
            font-family: monospace;
            color: #212529; /* text-dark for readability */
          }
          .modal-backdrop {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1040;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .modal {
            z-index: 1050;
            display: none;
            overflow: hidden;
            overflow-y: auto;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          .modal.show {
            display: block;
          }
          .modal-dialog {
            max-width: 500px;
            margin: 1.75rem auto;
            pointer-events: none;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
          }
          .modal.fade .modal-dialog {
            transition: transform 0.3s ease-out;
            transform: translateY(-100%);
          }
          .modal.show .modal-dialog {
            transform: translateY(-50%);
          }
          .modal-content {
            background-color: #fff;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 0.3rem;
            pointer-events: auto;
          }
        `}
      </style>

      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="mt-2 mb-4">
                <h1 className="title1 text-dark">Fund Your Account</h1>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card bg-light">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <form onSubmit={handleSubmit}>
                            <div className="row">
                              <div className="mb-4 col-md-12">
                                <h5 className="card-title text-dark">Enter Amount</h5>
                                <input
                                  className="form-control text-dark bg-light"
                                  placeholder="Enter Amount"
                                  type="number"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  required
                                  min="0"
                                  step="0.01"
                                />
                              </div>
                              <div className="mt-2 mb-1 col-md-12">
                                <h5 className="card-title text-dark">Choose Payment Method</h5>
                                <select
                                  className="custom-select"
                                  value={selectedMethod}
                                  onChange={(e) => setSelectedMethod(e.target.value)}
                                  required
                                >
                                  <option value="" disabled>Select a payment method</option>
                                  {Object.keys(walletAddresses).map((method) => (
                                    <option key={method} value={method}>{method}</option>
                                  ))}
                                </select>
                              </div>
                              {selectedMethod && walletAddresses[selectedMethod] && (
                                <div className="col-md-12 qr-code-container">
                                  <h5 className="card-title text-dark">{selectedMethod} Wallet Address</h5>
                                  <QRCodeCanvas value={walletAddresses[selectedMethod]} size={128} />
                                  <p className="wallet-address">{walletAddresses[selectedMethod]}</p>
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary mt-2"
                                    onClick={copyToClipboard}
                                  >
                                    Copy Address
                                  </button>
                                </div>
                              )}
                              <div className="mt-4 col-md-12">
                                <button
                                  type="submit"
                                  className="px-5 btn btn-primary btn-lg"
                                  disabled={submitting}
                                >
                                  {submitting ? "Processing..." : "Proceed to Payment"}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<Footer/>
            <div
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                zIndex: 1,
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxSizing: "content-box",
                  textAlign: "right",
                  lineHeight: "14px",
                  fontSize: "12px",
                  fontFeatureSettings: "normal",
                  textSizeAdjust: "100%",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                <div style={{ height: "40px" }}>
                  <iframe
                    src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505&invert_hover="
                    width="100%"
                    height={36}
                    scrolling="auto"
                    marginWidth={0}
                    marginHeight={0}
                    frameBorder={0}
                    border={0}
                    style={{ border: 0, margin: 0, padding: 0 }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <>
          <div className="modal fade show d-block" id="depositModal" tabIndex="-1" aria-labelledby="depositModalLabel">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="depositModalLabel">Deposit Request Submitted</h5>
                  <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <p>Your deposit request for <span style={{ color: "#212529" }}>${parseFloat(amount).toFixed(2)}</span> via <span style={{ color: "#212529" }}>{selectedMethod}</span> has been submitted.</p>
                  <p>Please send the amount to the following wallet address:</p>
                  <p className="wallet-address">{walletAddresses[selectedMethod] || "Not available"}</p>
                  <button type="button" className="btn btn-outline-secondary" onClick={copyToClipboard}>
                    Copy Address
                  </button>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={handleCloseModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={handleCloseModal}></div>
        </>
      )}
    </div>
  );
}

export default Deposit;
